import React from 'react'
import asset from './images/windows.png'
export const Windows = (props) => <img src={asset} alt="sistema operacional windows" {...props} />
